import type { IFlex } from './Flex';

import Flex from './Flex';

export type { IFlex };
export default Flex;
